import { IconButton, IconButtonProps } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

interface NavigationButtonProps extends Omit<IconButtonProps, 'children'> {
    direction: 'left' | 'right';
    disabled?: boolean;
}

const NavigationButton = ({
    direction,
    disabled = false,
    onClick,
    sx = {},
    ...props
}: NavigationButtonProps) => {
    const buttonStyles = {
        color: "#fff",
        opacity: 0.6,
        width: 25,
        height: 25,
        backgroundColor: "#0073e6",
        "&:hover": {
            backgroundColor: "#0073e6",
        },
        "&.Mui-disabled": {
            backgroundColor: "rgba(0, 0, 0, 0.23)",
            color: "#000",
            opacity: 0.6,
        },
        ...sx
    };

    return (
        <IconButton
            onClick={onClick}
            disabled={disabled}
            sx={buttonStyles}
            {...props}
        >
            {direction === 'left' ? (
                <ChevronLeftIcon fontSize="small" />
            ) : (
                <ChevronRightIcon fontSize="small" />
            )}
        </IconButton>
    );
};

export default NavigationButton;
